import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { get } from '../../services/http'
import { SliceStatus } from '../../interfaces/Redux';
import routeListen from '../../services/routeListen';
import { Comments, Social, defaultContent } from '../../interfaces/Social';

export interface AppState {
  social: Social,
  status: SliceStatus,
  error?: string | undefined
}

const initialState: AppState = {
  social: defaultContent,
  status: SliceStatus.idle,
  error: '',
}

export enum SortOrder {
  Newest=0,
  Oldest=1

}

export const socialSlice = createSlice({
  name: 'social',
  initialState,
  reducers: {
    reset: (state, action) => {
      state.status = SliceStatus.idle
    },
    clearComments: (state) => {
      state.social.comments = [];
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchSocial.pending, (state, action) => {
        state.status = SliceStatus.loading;
        state.error = undefined;
      })
      .addCase(fetchSocial.fulfilled, (state, action) => {
        if(action.payload) {
          state.status = SliceStatus.succeeded;
          state.social = {
            ...action.payload,
            comments: state.social.comments
          };
          state.error = undefined;
        }
      })
      .addCase(fetchSocial.rejected, (state, action) => {
        state.status = SliceStatus.failed;
        state.social = defaultContent;
        state.error = action.error.message;
      })
      .addCase(fetchMoreComments.pending, (state, action) => {
        state.status = SliceStatus.loading;
        state.error = undefined;
      })
      .addCase(fetchMoreComments.fulfilled, (state, action) => {
        if(action.payload) {
          state.social.comments = (action.payload as any).isAppend 
            ? [...state.social.comments, ...action.payload.comments]
            : action.payload.comments
          state.social.hasNext = !!(action.payload as Comments).nextUrl
        }
      })
      .addCase(fetchMoreComments.rejected, (state, action) => {


      })


  }
})

export const fetchSocial = createAsyncThunk('social/fetchSocial', async (contentId:string) => {

    const { data } = await get(`api/app/${routeListen.appGuid()}/content/${contentId}/social`)

    if (data) {
        return data as Social
    }

    return defaultContent
});

export const fetchMoreComments = createAsyncThunk('social/fetchMoreComments', async ({contentId, skip, sortOrder, top=20}:{contentId:string, skip:number, sortOrder: SortOrder, top?:number}) => {
  
  const { data } = await get(`api/app/${routeListen.appGuid()}/content/${contentId}/social/comments?Top=${top}&Skip=${skip}&DateCreatedSortOrder=${sortOrder}`)

  if (data) {
    return {
      ...data,
      isAppend: skip > 0
    } as Comments
}

  return defaultContent
});

export const {reset, clearComments} = socialSlice.actions;

export default socialSlice.reducer